import { useMenu, useHeadlessSeries } from "hooks";
import React from "react";
import { client, PageIdType } from "client";
import Layout from "layouts/main";
export default function Page() {
  const { usePage } = client;
  const chapters = useHeadlessSeries();
  const headerLinks = useMenu("PRIMARY");
  const footerLinks = useMenu("FOOTER");

  const page = usePage({
    id: `/headless`,
    idType: PageIdType.URI,
  });

  return (
    <Layout page={page} headerLinks={headerLinks} footerLinks={footerLinks}>
      <div className="bg-gray-100">
        <div className="bg-blue-dark text-white">
          <div className="mx-auto max-w-5xl px-6 lg:px-8 py-16 relative">
            <h1 className="leading-tight font-normal">
              A Complete Guide to Headless Websites, Applications, and Platforms
            </h1>

            <p className="text-xl mt-4">Your headless journey starts here!</p>
            <img
              className="hidden lg:block absolute w-48 right-0 bottom-4"
              src="/images/cloud.svg"
              alt="cloud icon"
            />
          </div>
        </div>
        <main>
          <div className="mx-auto max-w-3xl px-6 lg:px-8 py-16">
            <p className="text-lg">
              If you want to learn more about headless or decoupled approaches
              to building websites, applications or platforms, you’ve come to
              the right place. This guide will walk you through the basics and
              even get into some of the more nitty gritty details!
            </p>
          </div>
          <div className="pb-8">
            {chapters &&
              chapters.map((chapter) => (
                <a href={chapter?.link} key={chapter.slug} id={chapter.slug}>
                  <div className="mx-auto max-w-3xl px-6 lg:px-8 py-16 bg-white rounded-2xl my-6 grid grid-cols-2 hover:bg-gray-200">
                    <div className="w-1/3 m-auto">
                      <img src={chapter.icon} alt="icon" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold mb-4">
                        {chapter.title}
                      </h2>
                      <p className="text-lg">{chapter.content}</p>
                    </div>
                  </div>
                </a>
              ))}
          </div>
          {/* <div className="mx-auto max-w-3xl px-6 lg:px-8 py-16">
            <h3>Headless Glossary</h3>
          </div> */}
        </main>
      </div>
    </Layout>
  );
}
